import React, { useContext, useEffect, useState } from "react"
import { HeartIcon } from "@phosphor-icons/react"
import Tooltip from "./Tooltip"
import { toast } from "react-toastify"
import { Toast } from "@components/ToastTemplates/Toast"
import UserContext from "@context/UserContext"

const AddToWishListButton = ({
	data,
	className = "text-black",
	onClick,
	heartSize = "16",
	disableTooltip = false,
	noRoundedBg = false,
	inSingleProductPage,
}) => {
	const { visitorWishlist, visitorAddToWishlist, visitorRemoveFromWishlist } = useContext(UserContext)
	const [isAddedToWishlist, setIsAddedToWishlist] = useState(false)
	const [checkFlag, setCheckFlag] = useState(false)

	useEffect(() => {
		// init icon state
		if(checkFlag) return
		
		if(visitorWishlist) {
			const index = visitorWishlist.findIndex(item => item?.handle === data?.handle)
			if(index !== -1) setIsAddedToWishlist(true)
		}
		setCheckFlag(true)

	}, [visitorWishlist])

	const handleOnClick = (e) => {
		const hackBool = !isAddedToWishlist
		if(hackBool) visitorAddToWishlist(data)
		else visitorRemoveFromWishlist(data)
		setIsAddedToWishlist(!isAddedToWishlist)
		const toastId = toast(
			<Toast
				type="success"
				title="Success!"
				message={`Successfully ${hackBool ? 'saved to ' : 'removed from '}your wishlist.`}
				handleClose={() => toast.dismiss(toastId)}
			/>
		)

		if (onClick) onClick(e)
	}

	return (
		<React.Fragment>
			<button
				className={`${!noRoundedBg && "icon-round-bg p-2"} ${className}`}
				onClick={(e) => handleOnClick(e)}
			>
				{disableTooltip ? (
					<HeartIcon
						className=""
						size={heartSize}
						weight={isAddedToWishlist ? "fill" : "light"}
					/>
				) : (
					<Tooltip
						text={
							isAddedToWishlist ? "Remove from wishlist" : "Save to Wishlist"
						}
						offsetBubble="bottom-5"
						offsetBubblePointer="top-3"
					>
						<HeartIcon
							className=""
							size={heartSize}
							weight={isAddedToWishlist ? "fill" : "light"}
						/>
					</Tooltip>
				)}
			</button>
		</React.Fragment>
	)
}

export default AddToWishListButton
